
import { AWSFile } from "@/models/aws-file";
import { Contact } from "@/models/base";
import { ContactAwsDocument } from "@/models/base/contact-aws-document";
import Vue from "vue";
import AppAwsFilesInfo from "@/components/aws-files-modules/AwsFilesInfo.vue";

export default Vue.extend({
	data(){
		return {
			showPreview: false,
			previewFile: {} as AWSFile
		};
	},
	props: {
		contact: {
			type: Object as ()=>Contact,
			required: true
		}
	},
	computed: {
		items():ContactAwsDocument[] {
			return this.contact.AWSDocuments.filter(f=>f.File != null);
		},
	},
	components: {
		AppAwsFilesInfo
	}
});
